"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbItem = exports.Breadcrumbs = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const Breadcrumbs = (props) => {
    if (props.hidden)
        return null;
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const contentId = spa_core_1.Services.ContentLink.createApiId(props.currentContent);
    const [ancestors, setAncestors] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        api.getAncestors(props.currentContent).then(x => {
            if (isCancelled)
                return;
            setAncestors(x.reverse());
        });
        return () => { isCancelled = true; };
    }, [contentId, props.lang]);
    const itemKey = `BreadCrumb-Link-${contentId}-${contentId}`;
    return react_1.default.createElement("nav", { "aria-label": "breadcrumb" },
        react_1.default.createElement("ol", { className: "breadcrumb py-3" },
            ancestors.map(i => {
                if (!i.parentLink || i.contentType.indexOf('FolderPage') !== -1)
                    return null;
                const key = `BreadCrumb-Link-${contentId}-${spa_core_1.Services.ContentLink.createApiId(i)}`;
                return react_1.default.createElement(exports.BreadcrumbItem, { currentContent: i, key: key });
            }),
            react_1.default.createElement(exports.BreadcrumbItem, { currentContent: props.currentContent, key: itemKey, current: true })));
};
exports.Breadcrumbs = Breadcrumbs;
const BreadcrumbItem = (props) => {
    const name = spa_core_1.ContentDelivery.namePropertyIsString(props.currentContent.name) ? props.currentContent.name : props.currentContent.name.value;
    if (!props.current)
        return react_1.default.createElement("li", { className: "breadcrumb-item d-inline-flex align-items-center" },
            react_1.default.createElement(spa_core_1.Components.Link, { className: props.current ? 'link_black fw-bold' : 'link_black', href: props.currentContent }, name),
            react_1.default.createElement("i", { className: 'icon-right-arrow' },
                react_1.default.createElement("span", { className: 'visually-hidden' }, "separator")));
    return react_1.default.createElement("li", { className: "breadcrumb-item d-inline-flex align-items-center small-bold" }, name);
};
exports.BreadcrumbItem = BreadcrumbItem;
exports.default = exports.Breadcrumbs;
